import React, { Component } from 'react';
import { bool, func, string, object } from 'prop-types';

import { connect } from 'react-redux';

import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

import EsmsModal from '../../components/EsmsModal';
import CancelButton from '../../components/CancelButton';
import ConfirmButton from '../../components/ConfirmButton';

import { TimezoneOffsets } from '../../helpers/timezones';
import validator from '../../helpers/validator';

import * as ApplicationMessageActions from '../../actions/applicationMessageActions';
import * as BasAgentActions from '../../actions/basAgentActions';

import classes from './RenameAgentModal.module.css';

class UpdateAgentTimeZoneModal extends Component {
    state = {
        event:        null,
        formIsValid:  false,
        formControls: {
            timeZone: {
                value:           '',
                placeholder:     'Select Time Zone',
                valid:           false,
                touched:         false,
                message:         '',
                validationRules: {

                }
            }
        }
    }

    setInternalModel = () => {
        const updatedControls = {
            ...this.state.formControls
        };
        const { agent } = this.props;

        const timeZone = TimezoneOffsets.find(({ name }) => name === agent.timeZone);

        updatedControls.timeZone.value = timeZone || {};
        updatedControls.timeZone.touched = true;
        updatedControls.timeZone.valid = true;

        this.setState({
            formControls: updatedControls
        });
    }

    handleValidation = event => {
        const validatedState = validator(this.state, event);

        this.setState({
            formControls: validatedState.updatedControls,
            formIsValid:  validatedState.formIsValid
        });
    }

    handleChange = event => {
        const { name, value } = event.target;
        const updatedControls = { ...this.state.formControls };

        updatedControls[name].value = value;

        this.setState({
            formControls: updatedControls
        });
    }

    handleUpdate = async () => {
        const { companyInfo, agent, updateBasAgent } = this.props;

        const body = {
            timeZone:       this.state.formControls.timeZone.value.name,
            timeZoneOffset: this.state.formControls.timeZone.value.offset
        };

        const isRenamed = await updateBasAgent(companyInfo.companyId, agent.id, body);

        if (isRenamed) this.handleClose();
    }

    handleClose = () => {
        this.props.clearErrors();

        this.props.close();
    }

    render() {
        const { errors, open, title } = this.props;

        return (
            <EsmsModal
                errors={errors}
                imgSrc="/assets/images/basAgentIconColor.svg"
                open={open}
                onClose={this.handleClose}
                title={title}
                onRendered={this.setInternalModel}
            >
                <p>
                    Please enter the new Time Zone for this Agent.
                </p>

                <FormControl className={`${classes.inputWrapper} ${classes.timeZoneWrapper}`}>
                    <InputLabel
                        htmlFor="timeZoneList"
                        classes={{
                            focused: classes.labelFocused,
                            root:    classes.label
                        }}
                    >
                        {this.state.formControls.timeZone.placeholder}
                    </InputLabel>
                    <Select
                        value={this.state.formControls.timeZone.value}
                        onChange={this.handleChange}
                        className={classes.select}
                        inputProps={{
                            name:   'timeZone',
                            id:     'timeZone',
                            onBlur: this.handleValidation
                        }}
                    >
                        {
                            TimezoneOffsets.map(zone =>
                                <MenuItem
                                    key={zone.name}
                                    value={zone}
                                >
                                    {zone.name}
                                </MenuItem>
                            )
                        }
                    </Select>
                    {!this.state.formControls.timeZone.valid &&
                     this.state.formControls.timeZone.touched && <FormHelperText className={classes.error}>{this.state.formControls.timeZone.message}</FormHelperText>}
                </FormControl>
                <div className={classes.buttonContainer}>
                    <CancelButton cancel={this.handleClose} />
                    <ConfirmButton
                        confirm={this.handleUpdate}
                        label="Update Time Zone"
                        type="button"
                        disabled={!this.state.formControls.timeZone.value}
                    />
                </div>
            </EsmsModal>
        );
    }
}

UpdateAgentTimeZoneModal.propTypes = {
    agent: object.isRequired,
    close: func.isRequired,
    open:  bool.isRequired,
    title: string.isRequired
};

const mapStateToProps = state => {
    return {
        companyInfo: state.companyInfo,
        errors:      state.messages.errors
    };
};

const mapDispatchToProps = {
    ...ApplicationMessageActions,
    ...BasAgentActions
};

export default connect(mapStateToProps, mapDispatchToProps)(UpdateAgentTimeZoneModal);
